export default "__VITE_ASSET__8e1afb47__"